import { Phone, MapPin, Clock, Facebook, Instagram, Twitter } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_premium-tire-hub-1/artifacts/lhewl2tw_2026-03-07%2021.47.25.jpg";

export const Footer = ({ settings }) => {
  const currentYear = new Date().getFullYear();

  // Use settings from CMS or defaults
  const phone = settings?.phone || '(410) 123-4567';
  const addressLine1 = settings?.address_line1 || '51 Main Street, Suite B';
  const addressLine2 = settings?.address_line2 || 'Reisterstown, MD 21136';
  const hoursWeekday = settings?.hours_weekday || 'Mon-Sat: 8AM - 6PM';
  const hoursWeekend = settings?.hours_weekend || 'Sunday: Closed';
  const facebookUrl = settings?.facebook_url || 'https://facebook.com';
  const instagramUrl = settings?.instagram_url || 'https://instagram.com';
  const twitterUrl = settings?.twitter_url || 'https://twitter.com';

  // Format phone for tel: link
  const phoneLink = phone.replace(/\D/g, '');

  return (
    <footer className="bg-[#050505] border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="lg:col-span-2">
            <img 
              src={LOGO_URL} 
              alt="Perry D Tires" 
              className="h-16 w-auto mb-4"
              data-testid="footer-logo"
            />
            <p className="font-body text-white/60 max-w-md mb-6">
              Your trusted source for new and quality used tires in Reisterstown, MD. 
              Professional service, competitive prices, and expert technicians.
            </p>
            <div className="flex gap-4">
              <a 
                href={facebookUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white/20 flex items-center justify-center hover:border-[#FF2E2E] hover:bg-[#FF2E2E]/10 transition-all"
                data-testid="social-facebook"
              >
                <Facebook className="w-5 h-5 text-white/60 hover:text-[#FF2E2E]" />
              </a>
              <a 
                href={instagramUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white/20 flex items-center justify-center hover:border-[#FF2E2E] hover:bg-[#FF2E2E]/10 transition-all"
                data-testid="social-instagram"
              >
                <Instagram className="w-5 h-5 text-white/60 hover:text-[#FF2E2E]" />
              </a>
              <a 
                href={twitterUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white/20 flex items-center justify-center hover:border-[#FF2E2E] hover:bg-[#FF2E2E]/10 transition-all"
                data-testid="social-twitter"
              >
                <Twitter className="w-5 h-5 text-white/60 hover:text-[#FF2E2E]" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg text-white mb-4">Quick Links</h4>
            <ul className="space-y-3">
              {['Home', 'Services', 'Tire Catalog', 'Reviews', 'Contact'].map((link) => (
                <li key={link}>
                  <a 
                    href={`#${link.toLowerCase().replace(' ', '-')}`}
                    className="font-body text-white/60 hover:text-[#FF2E2E] transition-colors"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-lg text-white mb-4">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#FF2E2E] mt-0.5" />
                <span className="font-body text-white/60">
                  {addressLine1}<br />
                  {addressLine2}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#FF2E2E]" />
                <a href={`tel:+1${phoneLink}`} className="font-body text-white/60 hover:text-[#FF2E2E] transition-colors">
                  {phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-[#FF2E2E] mt-0.5" />
                <span className="font-body text-white/60">
                  {hoursWeekday}<br />
                  {hoursWeekend}
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-body text-white/40 text-sm">
            © {currentYear} Perry D Tires. All rights reserved.
          </p>
          <p className="font-body text-white/40 text-sm">
            New and Used Tires • Quality and Speed
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
